/* TrackerBase signout button directive
 * 
 * Angular module: "trackerbase-app.directives.tb-signout"
 * Controller: (not exposed: TbSignOutController)
 * Controller instance name in template: tbSignOutCtrl
 * Directive name: "tbSignOut" or "tb-sign-out"
 *
 */

import angular from "angular";

import uiRouter from "@uirouter/angularjs";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

import UserAuthModuleConstants from "./ModuleConstants";
import TbSignOutController from "./TbSignOutController";

class TbSignOutDirective {
    constructor() {
        this.scope = true;
        this.controller = TbSignOutController; //injector needs in $inject
        this.controllerAs = TbSignOutController.controllerAs;
        this.bindToController = true;
        this.restrict = "E";
        this.template = TbSignOutController.template;
        this.replace = true;
    }
}

function TbSignOutDirectiveFactory() {
    return new TbSignOutDirective();
}

TbSignOutDirectiveFactory.$inject = [];

const tbSignOutDirectiveDependencies = DependencyListBuilder([
    TbSignOutController.dependencies,
    [
        uiRouter
    ]
]);

export default angular
    .module(
        `${UserAuthModuleConstants.module_name}.tb-sign-out`,
        tbSignOutDirectiveDependencies
    )
    .directive("tbSignOut", TbSignOutDirectiveFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/directives/user-auth/TbSignOut.js
// module id = IB0/
// module chunks = 1